'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00246 from "./presto.-Register-Page-View$$anon$6.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$5() {
  this.buB = null;
  this.but = null;
  this.buu = false;
  this.buC = null;
  this.buD = false;
  this.buG = null;
  this.buz = null;
  this.buA = false;
  this.buv = null;
  this.buw = false;
  this.bux = null;
  this.buy = false;
  this.buE = false;
  this.buF = false;
  this.buB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.buG = "MorbidUserDetails";
}
export { $c_Lpresto_RegisterPageView$$anon$5 as $c_Lpresto_RegisterPageView$$anon$5 };
$p = $c_Lpresto_RegisterPageView$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$5;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$5() {
}
export { $h_Lpresto_RegisterPageView$$anon$5 as $h_Lpresto_RegisterPageView$$anon$5 };
$h_Lpresto_RegisterPageView$$anon$5.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.buB;
});
$p.L = (function() {
  if ((!this.buu)) {
    this.but = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.buu = true;
  }
  return this.but;
});
$p.O = (function() {
  if ((!this.buD)) {
    this.buC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.buD = true;
  }
  return this.buC;
});
$p.E = (function() {
  return this.buG;
});
$p.t = (function() {
  if ((!this.buA)) {
    this.buz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.buA = true;
  }
  return this.buz;
});
$p.M = (function() {
  if ((!this.buw)) {
    this.buv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cG(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.buw = true;
  }
  return this.buv;
});
$p.Q = (function() {
  if ((!this.buy)) {
    this.bux = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00246.$c_Lpresto_RegisterPageView$$anon$6();
    this.buy = true;
  }
  return this.bux;
});
$p.w = (function() {
  if ((!this.buF)) {
    this.buE = false;
    this.buF = true;
  }
  return this.buE;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee48) => ((p) => \u03b4scrutinee48.GD(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_RegisterPageView$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$5, "presto.RegisterPageView$$anon$5", ({
  Q4: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$5 as $d_Lpresto_RegisterPageView$$anon$5 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$5.js.map
